import { DownOutlined, FolderOpenTwoTone, LoadingOutlined } from '@ant-design/icons';
import { Spin, Tree } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { useEffect, useState } from "react";
import { Button, Modal, Row, Col, Table } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import { arrayCommonElement } from '../../helpers/common';
import { Links } from '../../helpers/Links';
import { ChucNangQuyenRequest, QuyenResponse } from '../../models/quyen/Quyen';
import { layDanhSachChucNangTreeView, layDSChucNangTheoIdQuyen} from '../../services/chucnang';
import { layDSTatCaQuyen, luuChucNangTheoQuyen, xoaQuyen } from '../../services/quyen';

const convertDataTreeView = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {

                key: _item?.id,
                title: " " + _item?.tenChucNang,
                icon: <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" />,
                children: convertDataTreeView(_item?.children)
            }
            return rs;
        })
    }
    return chidlrenArr;
}
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev="" />;
const DanhSachQuyen = () => {
    const navigate = useNavigate();
    const [canSave, setCanSave] = useState(false);
    const [dsQuyen, setDsQuyen] = useState<Array<QuyenResponse>>([]);
    const [idQuyen, setIdQuyen] = useState<number>(0);
    const [openModalSave, setOpenModalSave] = useState<boolean>(false);
    const [chucNangSelected, setChucNangSelected] = useState<number>(0);
    const [checkedKeys, setCheckedKeys] = useState<Array<number>>([]);
    const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true);
    const [expandedKeys, setExpandedKeys] = useState<Array<number>>([]);
    const [treeData, setTreeData] = useState<Array<DataNode>>([]);
    const [loadingTree, setLoadingTree] = useState<boolean>(false);
    const [openModalXoa, setOpenModalXoa] = useState<boolean>(false);
    const [reloadTree, setReloadTree] = useState<boolean>(true);
    
    const onExpand = (expandedKeysValue: any) => {
        setExpandedKeys(expandedKeysValue);
        setAutoExpandParent(false);
    };
    const onCheckTree = (checkedKeysValue: any) => {
        setCheckedKeys(checkedKeysValue.checked || []);
    };
    const laydsChucNang = async () => {
        try {
            setLoadingTree(true);
            let data = await layDanhSachChucNangTreeView();
            setTreeData(convertDataTreeView(data));
            setLoadingTree(false);
        } catch (error: any) {
            setLoadingTree(false);
        };
    }
    const laydsChucNangTheoIdQuyen = async (id: number) => {
        try {
            let data = await layDSChucNangTheoIdQuyen(id);
            var temp = data.map((item) => item.id) as number[];
            var expandedTemp: Array<number> = [];
            data.forEach((item) => {
                if (item.idCha != null || item.idCha != 0) {
                    expandedTemp.push(item.idCha)
                };
            })
            var expanded = Array.from(new Set(expandedTemp));
            setExpandedKeys(expanded);
            setCheckedKeys(temp);
        } catch (error: any) {
            throw error;
        };
    }
    const getLeafKeys = (inputList: Array<DataNode>) => {
        let leafKeys: Array<number> = [];
        inputList.forEach((node) => {
            if (node.children && node.children.length > 0) {
                const childLeafNodes = getLeafKeys(node.children);
                leafKeys.push(...childLeafNodes);
            } else {
                leafKeys.push(node.key as number);
            }
        });
        return leafKeys;
    }
    const laydsQuyen = async () => {
        try {
            setLoadingTree(true);
            let data = await layDSTatCaQuyen();
            setDsQuyen(data);
            setLoadingTree(false);
        } catch (error: any) {
            setLoadingTree(false);
        };
    }
    const onChangeQuyen = (id: number) => {
        setCanSave(true);
        setIdQuyen(id);
        laydsChucNangTheoIdQuyen(id);
        setCheckedKeys(checkedKeys);
        setAutoExpandParent(true)
    }
    const onSave = async (idQuyen: number) => {
        setOpenModalSave(false);
        var allLeafs = getLeafKeys(treeData);
        let chucNangRequest = arrayCommonElement.findCommonElements(allLeafs, checkedKeys);
        let requestSave: ChucNangQuyenRequest = {
            id: idQuyen,
            chucNang: checkedKeys // chucNangRequest
        }
        let rs = await luuChucNangTheoQuyen(requestSave);
        if (rs === true) {
            toast.success('Cập nhật chức năng theo quyền thành công!')
            setReloadTree(true);
        }
        else {
            toast.error('Cập nhật chức năng theo quyền thất bại!')
        }
    }
    const onDelete = async (id: number) => {
        let rs = await xoaQuyen(id);
        if (rs === true) {
            toast.success('Xoá quyền thành công');
            window.location.reload()
            setOpenModalXoa(false)
        }
        else {
            toast.success('Xoá quyền không thành công')
            setOpenModalXoa(false)
        }
    }
    useEffect(() => {
        if (reloadTree) {
            laydsChucNang();
            laydsQuyen();
            setReloadTree(false);
        }
    }, [reloadTree]);
    return (<section>
        <Modal show={openModalXoa} onHide={() => setOpenModalXoa(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Xóa quyền</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Bạn có muốn xóa quyền không?
                <br />
                <strong><span className="text-red">Lưu ý:</span></strong> Sẽ xóa các chức năng liên quan.
            </Modal.Body>
            <Modal.Footer style={{
                "display": "flex",
                "justifyContent": "space-between"
            }}>
                <Button variant="secondary" className="btn-sm" onClick={() => setOpenModalXoa(false)}>
                    Đóng
                </Button>
                <Button variant="danger" className="btn-sm" onClick={() => onDelete(idQuyen)}>
                    Xóa
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal show={openModalSave} onHide={() => setOpenModalSave(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Cập nhật chức năng cho quyền</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Bạn có muốn cập nhật danh sách chức năng không?
            </Modal.Body>
            <Modal.Footer style={{
                "display": "flex",
                "justifyContent": "space-between"
            } }>
                <Button variant="secondary" className="btn-sm" onClick={() => setOpenModalSave(false)}>
                    Đóng
                </Button>
                <Button variant="primary" className="btn-sm" onClick={() => onSave(idQuyen)}>
                    Xác nhận
                </Button>
            </Modal.Footer>
        </Modal>
        <ContentHeader title="Quản lý quyền" />
        <Row>
            <Col>
                <div className="card card-primary card-outline">
                    <div className="card-header">
                        <h3 className="card-title">Danh sách quyền</h3>
                        <div className="float-right card-tools">
                            <Link to={Links.Quyen.ChiTiet} title="Chỉnh sửa">
                                <Button className="btn btn-success btn-sm pull-right" type="button" title="Thêm mới" ><i className="fa fa-plus" /></Button>
                            </Link>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-sm-12">
                                {loadingTree ?
                                    <Spin indicator={antIcon} />
                                    :
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th className="text-center align-middle" style={{ width: "5%" }}>STT</th>
                                                <th className="text-center align-middle">Tên quyền</th>
                                                <th className="text-center align-middle" style={{ width: "120px" }}>Hành động</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dsQuyen.length === 0
                                                ? <tr><td style={{ "textAlign": "center" }} colSpan={5}>Chưa có thông tin</td></tr>
                                                : dsQuyen?.map((item, index) => {
                                                    return <tr onClick={() => onChangeQuyen(item.id)} key={index} className={item.id === idQuyen ? "bg-success" : ""}>
                                                        <td className="text-center align-middle">{index + 1}</td>
                                                        <td className="text-left align-middle">{item?.tenQuyen}</td>
                                                        <td className="text-center align-middle">
                                                            <Link to={Links.Quyen.ChiTiet + "?id=" + item?.id} title="Chỉnh sửa">
                                                                <Button className="btn btn-primary btn-sm" type="button" title="Chi tiết"><i className="fa fa-eye" /></Button>
                                                            </Link>
                                                            <Button className="btn btn-danger btn-sm ml-2" type="button" onClick={() => setOpenModalXoa(true)} title="Xoá"><i className="fa fa-trash" /></Button>
                                                        </td>
                                                    </tr>
                                                })}
                                        </tbody>
                                    </Table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
            <Col>
                <div className="card card-primary card-outline">
                    <div className="card-header">
                        <h3 className="card-title">Danh sách chức năng</h3>
                        <div className="float-right card-tools">
                            {canSave ? <Button className="btn btn-success btn-sm pull-right" type="button" onClick={() => setOpenModalSave(true)} title="Lưu" ><i className="fa fa-save" /></Button> : null}
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-sm-6">
                                {loadingTree ?
                                    <Spin indicator={antIcon} />
                                    : <div id="treeView">
                                        <Tree
                                            checkable={canSave ? true : false}
                                            showIcon
                                            showLine
                                            multiple={true}
                                            switcherIcon={<DownOutlined rev="" />}
                                            treeData={treeData}
                                            onCheck={onCheckTree}
                                            checkedKeys={checkedKeys}
                                            selectedKeys={[chucNangSelected]}
                                            autoExpandParent={autoExpandParent}
                                            onExpand={onExpand}
                                            checkStrictly
                                            expandedKeys={expandedKeys}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    </section>
    );
};

export default DanhSachQuyen;
